import papaparse from "papaparse";

import { coerceToString } from "src/utils/stringUtils";

export const rowsToCsv = (rows: Record<string, unknown>[]): string =>
  papaparse.unparse(
    rows.map((row) =>
      Object.fromEntries(
        Object.entries(row).map(([column, value]) => [
          column,
          coerceToString(value),
        ]),
      ),
    ),
  );

const toCsvFileName = (name: string): string => {
  const base = name
    .trim()
    .replace(/[^a-z0-9-_]+/gi, "_")
    .replace(/^_+|_+$/g, "");
  return `${base || "table"}.csv`;
};

export const downloadRowsAsCsv = (
  rows: Record<string, unknown>[],
  name: string,
): void => {
  const blob = new Blob([rowsToCsv(rows)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = toCsvFileName(name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
